module.exports = __webpack_public_path__ + "img/qualified-tick.815f5d86.svg";